import React from "react"
import {
  OutlinedInput as MUIOutlinedInput,
  OutlinedInputProps as MUIOutlinedInputProps,
} from "@mui/material"

export type OutlinedInputProps =
  | ({ new?: false } & MUIOutlinedInputProps)
  | ({ new: true } & unknown)

export const OutlinedInput = React.forwardRef<
  HTMLDivElement,
  OutlinedInputProps
>((props, ref) =>
  props.new ? null : <MUIOutlinedInput {...props} ref={ref} />,
)

OutlinedInput.displayName = "OutlinedInput"

export default OutlinedInput
